// Builds a query-string fragment compatible with the V1 ApiFilter convention.
// Used by scenes to sync DocumentOverviewCard filter state with their table fetch.

export const buildPermanentFilter = ({
  statuses,
  dateFrom,
  dateTo,
  dateField,
}) => {
  const parts = [];
  // Multiple statuses must be OR-combined. The backend `statusIn` param maps to
  // a single whereIn() — repeated status[eq] would be AND-combined (always empty).
  if (Array.isArray(statuses) && statuses.length > 0) {
    parts.push(`statusIn=${statuses.join(',')}`);
  }
  if (dateFrom && dateField) {
    parts.push(`${dateField}[gte]=${encodeURIComponent(dateFrom)}`);
  }
  if (dateTo && dateField) {
    parts.push(`${dateField}[lte]=${encodeURIComponent(dateTo)}`);
  }
  return parts.join('&');
};
